import { ProposalsResource } from "@repo/core/services/resources/proposals";
import { filterIndividualPlProducts } from "../../screens/SelectProduct/utils";

import { getSingleValue, hasMultipleValues, hasNoValues } from "./utils";

type ResolveProductResult =
  | { status: "resolved"; productId: string }
  | { status: "needsSelection" }
  | { status: "unavailable" };

export const resolveProductForPreProposal = async (
  lstProdutos: string | string[] | undefined,
  proposalsResource: ProposalsResource
): Promise<ResolveProductResult> => {
  if (!hasNoValues(lstProdutos) && !hasMultipleValues(lstProdutos)) {
    const productId = getSingleValue(lstProdutos);
    if (productId) {
      return { status: "resolved", productId };
    }
  }

  try {
    const { data: products } = await proposalsResource.getProducts();
    const availableProducts = filterIndividualPlProducts(products ?? []);

    if (availableProducts.length === 0) {
      return { status: "unavailable" };
    }

    if (availableProducts.length === 1) {
      return { status: "resolved", productId: availableProducts[0].produto };
    }
  } catch (error) {
    console.error("Error fetching products for pre-proposal:", error);
  }

  return { status: "needsSelection" };
};
